export class AlertaUsuariosRequest {
   public alertaId: number;
   public emisorId: string;
   public usuarios: string[];
}
